import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HostedApp } from './app';
import { fetchPublishedBot } from './published-config';
import { slugFromLocation } from './slug';
import './styles.css';

const BASE_DOMAIN = 'bots.laivdata.com';

function Boot() {
  const [state, setState] = React.useState<
    | { status: 'loading' }
    | { status: 'error'; message: string }
    | { status: 'ready'; config: Awaited<ReturnType<typeof fetchPublishedBot>> }
  >({ status: 'loading' });

  React.useEffect(() => {
    const slug = slugFromLocation(window.location.hostname, window.location.search, BASE_DOMAIN);
    if (!slug) {
      setState({
        status: 'error',
        message: '봇 주소를 확인해 주세요. 예: https://my-bot.bots.laivdata.com',
      });
      return;
    }
    let alive = true;
    fetchPublishedBot(slug)
      .then((config) => {
        if (alive) {
          document.title = config.name || 'LangBridge';
          setState({ status: 'ready', config });
        }
      })
      .catch((err: unknown) => {
        if (alive) {
          setState({
            status: 'error',
            message: err instanceof Error ? err.message : '불러오지 못했어요.',
          });
        }
      });
    return () => {
      alive = false;
    };
  }, []);

  if (state.status === 'loading') {
    return (
      <div className="grid h-dvh place-items-center bg-app text-fg-muted" data-theme="saas" data-mode="dark">
        불러오는 중…
      </div>
    );
  }
  if (state.status === 'error') {
    return (
      <div
        className="grid h-dvh place-items-center bg-app px-6 text-center text-fg-muted"
        data-theme="saas"
        data-mode="dark"
      >
        {state.message}
      </div>
    );
  }
  return <HostedApp config={state.config} />;
}

const root = document.getElementById('root');
if (root) createRoot(root).render(<Boot />);
